import { getCookie, removeCookie, setCookie } from 'lib/utils/cookies';
import { Subscriptions } from 'lib/services/newsletter-signup-service';

export const HIDE_INTERSTITIAL_COOKIE = 'HideInterstitial';
const PAGE_COUNT_COOKIE = 'pageCount';
const USER_SUBSCRIPTIONS_COOKIE = 'userSubscriptions';
const DEFAULT_PRIVACY_COOKIES = ['OptanonAlertBoxClosed', 'OptanonConsent'];

export const getPageLoadCount = (): number => {
  if (typeof window === 'undefined') {
    return 0;
  }

  const existingValue = getCookie(PAGE_COUNT_COOKIE);
  const parsedValue = existingValue ? Number(existingValue) : 0;
  const nextValue = Number.isFinite(parsedValue) ? parsedValue + 1 : 1;

  setCookie(PAGE_COUNT_COOKIE, nextValue.toString());
  removeCookie('PageCount');

  return nextValue;
};

export const shouldHideFromCookie = (): boolean =>
  getCookie(HIDE_INTERSTITIAL_COOKIE)?.toLowerCase() === 'true';

export const setDismissedCookie = () => {
  setCookie(HIDE_INTERSTITIAL_COOKIE, 'true', 3);
};

export const hasAcceptedPrivacyPolicy = (): boolean =>
  DEFAULT_PRIVACY_COOKIES.some((cookieName) => !!getCookie(cookieName));

/**
 * Sets the userSubscriptions cookie with session-scoped expiry (no days = session cookie).
 * Stores an array of subscription IDs from the subscriptions that were signed up for.
 */
export const setUserSubscriptionsCookie = (subscriptions?: Subscriptions[]) => {
  if (!subscriptions?.length) {
    return;
  }

  const subscriptionIds = subscriptions.map((s) => s.SubscriptionId);
  setCookie(USER_SUBSCRIPTIONS_COOKIE, JSON.stringify(subscriptionIds));
};

/**
 * Checks whether all conditions (except the 6-second delay) are met to open the modal.
 * The delay is handled separately in the component — once this returns true the timer starts.
 */
export const canOpenNewsletterModal = ({
  shouldShowComponent,
  hasDismissed,
  pageLoadCount,
  hasScrolled,
  hasPrivacyConsent,
}: {
  shouldShowComponent: boolean;
  hasDismissed: boolean;
  pageLoadCount: number;
  hasScrolled: boolean;
  hasPrivacyConsent: boolean;
}): boolean => {
  if (!shouldShowComponent) {
    return false;
  }

  if (hasDismissed) {
    return false;
  }

  // page count managed here
  return pageLoadCount >= 2 && hasScrolled && hasPrivacyConsent;
};
